import {AdminProviderPhaseStatus, TenderStatus} from '@frontend/shared-api';
import {addDays} from '../../../../shared/utils/date-utils';

const SUBMISSION_DATE_STATUSES: ReadonlySet<TenderStatus> = new Set([
  TenderStatus.INVITED,
  TenderStatus.ACCEPTED,
  TenderStatus.PREPARED,
]);

export function isSubmissionDateStatus(status: TenderStatus): boolean {
  return SUBMISSION_DATE_STATUSES.has(status);
}

export function hasSubmissionDateWithin(
  providerStatus: AdminProviderPhaseStatus,
  days: number,
): boolean {
  return (
    !!providerStatus.submissionDate &&
    new Date(providerStatus.submissionDate) <= addDays(new Date(), days)
  );
}
